module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tyc"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4259a391"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/tyc.vue
// module id = 1025
// module chunks = 0